import { Deserializable } from '../deserializable';
import { Fia } from './fia';
import { UserTradingStatistics } from './userTradingStatistics';
export class TransactionDataBundle implements Deserializable {

    public totalTradeProfit: number;
    public fiaAvailable: Fia;
    public averageTradeProfit: number;
    public averageProfitPercentage: number;
    public noOfTrades: number;
    public fromDate: Date;
    public toDate: Date;

    public tradingStatistics: UserTradingStatistics;

    deserialize(input: any): this {
        Object.assign(this, input);
        return this;
    }
}
